export const initialState = {
  loadingStatus: {
    loadOrganisationListLoading: false,
    organisationDetailLoading: false,
    companySiteListLoading: false,
    companySiteDetailLoading: false,
  },
  organisationList: {
    data: [],
    offset: 0,
    limit: 0,
    total: 0,
  },

  organisationDetail: {},
  companySiteList: {
    data: [],
    offset: 0,
    limit: 0,
    total: 0,
  },
  companySiteDetail: {},
  error: '',
};
